import { publicClient } from './apiClients'

type CancelAppointmentParams = {
  appointmentBundleReferenceId: string
  authString: string
  acceptCancellationFee: boolean
}

export const cancelAppointment: (params: CancelAppointmentParams) => Promise<any> = async ({
  appointmentBundleReferenceId,
  authString,
  acceptCancellationFee,
}) => {
  const response = await publicClient.post(
    `/appointment-bundles/${appointmentBundleReferenceId}/cancellations`,
    {
      authString,
      acceptCancellationFee,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
  return response
}
